import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cta',
  templateUrl: './cta.component.html',
  styleUrls: ['./cta.component.scss'],
  standalone: false
})
export class CtaComponent {
  @Input() title = '¿Listo para transformar tu comunicación digital?';
  @Input() subtitle = 'Únete a las empresas que ya están aprovechando el poder de la IA conversacional con Zapphira.ai';
  @Input() primaryButtonText = 'Comenzar prueba gratis';
  @Input() secondaryButtonText = 'Ver demostración';
  @Input() theme: 'dark' | 'light' = 'dark';
  
  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();
  
  onPrimaryAction(): void {
    this.primaryAction.emit();
  }
  
  onSecondaryAction(): void {
    this.secondaryAction.emit();
  }
  
  get ctaClass(): string {
    return this.theme === 'light' ? 'cta cta--light' : 'cta';
  }
}